import { schema } from 'normalizr';

export const statement = new schema.Entity('statement');
export const statements = [ statement ];
